import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Case } from '../models/case';
import { ApiService } from './api.service';

@Injectable()
export class CommentService {

  apiService: ApiService = new ApiService(this.http);

  static baseURL = environment.commentLink;

  constructor(
    private http: Http
  ) { }

  getComment(orgId, caseId) {
    // return this.apiService.getCall('commentLink', `organizations/${orgId}/cases/${caseId}/comments`);
    return this.apiService.getCall('commentLink', `cases/${caseId}/comments`);
  }

  postComment(orgId, data) {
    return this.apiService.postCall('commentLink', `organizations/${orgId}/comments/`, data);
  }

  putComment(orgId, commentId, data) {
    return this.apiService.putCall('commentLink', `organizations/${orgId}/comments/${commentId}`, data);
  }

  postAlertComment(caseId: string, alertId: string, data: any) {
    return this.apiService.postCall('commentLink', `${CommentService.baseURL}cases/${caseId}/${alertId}/comments`, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/comment.service.ts